<template>
  <!-- 使用 Vant Popup 实现详情弹窗 -->
  <van-popup v-model="open" position="bottom" closeable :style="{ height: '70%' }" round>
    <div class="detailsInfo-popup">
      <div class="detailsInfo-header">
        <h3 class="title">{{ title }}</h3>
      </div>

      <div class="faceDatabase">
        <div class="faceDatabase_box">
          <!-- 图片 -->
          <div class="faceDatabase_box_imgBox">
            <image-preview :src="detailsForm.url" :width="100" :height="100" />
          </div>

          <!-- 名称 + 类型 -->
          <div class="faceDatabase_box_name">
            <span>{{ detailsForm.name }}</span>
            <span class="detailsInfo_span">
              （
              <span v-for="(item, index) in detailsForm.imageTypeList" :key="index">
                {{ item.type }}
              </span>
              ）
            </span>
          </div>

          <!-- 内容 -->
          <span class="faceDatabase_box_time">{{ detailsForm.content }}</span>

          <!-- 元信息：创建人、时间、平台 -->
          <div class="detailsInfo_box">
            <span class="faceDatabase_box_time">{{ detailsForm.createUser }}</span>
            <span class="faceDatabase_box_time">{{ detailsForm.createTime }}</span>
          </div>
        </div>
      </div>

      <!-- 操作按钮 -->
      <div class="dialog-footer">
        <van-button type="primary" block @click="cancel">确 定</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { imageLibraryinfo } from "@/api/imageLibrary";
import "@/assets/imgList.css";

export default {
  components: {},
  data() {
    return {
      title: "详情",
      open: false,
      btnShow: false,
      detailsNum: 3,
      detailsForm: {},
      id: null,
    };
  },
  methods: {
    // 打开弹窗并加载数据
    addCreateForm(record) {
      this.open = true;
      this.id = record.id;
      this.getImgFun();
    },
    // 请求详情数据
    getImgFun() {
      imageLibraryinfo({ id: this.id }).then((response) => {
        this.detailsForm = response.data.data;
      });
    },
    // 关闭弹窗
    cancel() {
      console.log("取消");
      this.detailsForm = {};
      this.open = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.detailsInfo-popup {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 90%;
  background-color: #f7f8fa;
}

.detailsInfo-header {
  text-align: center;
  margin-bottom: 16px;
}

.detailsInfo-header .title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.faceDatabase_box {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  text-align: center;
  width: 100%;
}

.faceDatabase_box_imgBox {
  margin: 0 auto 12px;
}

.faceDatabase_box_name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  word-break: break-all;
}

.detailsInfo_span {
  font-weight: 500;
  font-size: 14px;
  color: #1aaeae;
}

.faceDatabase_box_time {
  font-size: 13px;
  color: #666;
  display: block;
  margin: 6px 0;
}

.detailsInfo_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  color: #888;
}

.dialog-footer {
  margin-top: 20px;
}

/* 图片预览组件适配 */
.image-preview {
  border-radius: 8px;
}
</style>